module.exports = __webpack_public_path__ + "assets/img/a6143ee5e370a68176eafdfbb0a25f9b.png";